module.exports = __webpack_public_path__ + "static/lights1-64a11e58c97ba562c088b1ec407550be.jpg";